/**
 * Tarjeta base (patron shadcn/ui) en version kiosco: borde de 2px,
 * radios amplios y cabecera con titulo grande legible a metro y medio.
 */
import * as React from 'react';
import { cn } from '@/lib/utils';

export const Tarjeta = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'flex flex-col rounded-lg border-2 border-border bg-card text-card-foreground shadow-lg',
        className,
      )}
      {...props}
    />
  ),
);
Tarjeta.displayName = 'Tarjeta';

export const TarjetaCabecera = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('flex flex-col gap-2 p-6 pb-3', className)} {...props} />
));
TarjetaCabecera.displayName = 'TarjetaCabecera';

export const TarjetaTitulo = React.forwardRef<
  HTMLHeadingElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h2 ref={ref} className={cn('text-xl font-bold leading-tight', className)} {...props} />
));
TarjetaTitulo.displayName = 'TarjetaTitulo';

export const TarjetaDescripcion = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <p ref={ref} className={cn('text-sm text-muted-foreground', className)} {...props} />
));
TarjetaDescripcion.displayName = 'TarjetaDescripcion';

export const TarjetaContenido = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('flex-1 p-6 pt-3', className)} {...props} />
));
TarjetaContenido.displayName = 'TarjetaContenido';

export const TarjetaPie = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('flex items-center gap-4 p-6 pt-0', className)} {...props} />
  ),
);
TarjetaPie.displayName = 'TarjetaPie';
